import {Component, Input} from '@angular/core';
import {enumValue} from '../../../../constant.enum';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  enumValue = enumValue;
  @Input() pageTitle: string;
  primaryNavLogoLink = {
    href: 'https://www.thehartford.com/',
    id: 'logo-link',
    link: 'The Hartford'
  };

  constructor() {}
}
